export class GeoHierarchyandOrganization {
}
export class OrganizationEntityMaster
{
  intOrganizationEntityID:number;
}
export class EntityMaster
{
  intEntityID:number;
}
export class TicketCategory
{
  intTicketCategoryID:number;
}
export class GeoStructure
{
  intGeoStructureID:number;
}
export class DesignationMaster
{
  intDesignationID:number;
}
export class GeoStructureMaster
{
  intParentGeoStructureID:number;
}
export class AdminUserMaster
{
  intAdminUserID:number;
}
